export const paymentPlanLabels = {
    de: {
        sort: 'Sortierung',
        version: 'Version',
        export: 'Exportieren',
        title: 'Zahlungsplanung',
        hint: 'Plant Auszahlungen für gebuchte Lieferantenrechnungen. Ein Plan ist keine Zahlung, gleicht keinen Posten aus und wird nicht an eine Bank gesendet.',
        add: 'Zahlung planen',
        edit: 'Plan bearbeiten',
        cancel: 'Plan aufheben',
        cancelTitle: 'Zahlungsplan aufheben',
        cancelHint: 'Der Plan bleibt mit seiner Historie erhalten. Bereits erfasste Zahlungen bleiben bestehen.',
        invoice: 'Lieferantenrechnung',
        partner: 'Lieferant',
        plannedDate: 'Geplant am',
        dueDate: 'Fälligkeit',
        amount: 'Geplanter Teilbetrag',
        currency: 'Währung',
        openAmount: 'Aktuell offen',
        plannedTotal: 'Insgesamt geplant',
        availableAmount: 'Noch planbar',
        moneyAccount: 'Vorgesehenes Geldkonto',
        unassigned: 'Noch nicht festgelegt',
        note: 'Notiz',
        reason: 'Begründung der Änderung',
        state: 'Status',
        warning: 'Prüfhinweis',
        PLANNED: 'Geplant',
        CANCELLED: 'Aufgehoben',
        SETTLED: 'Posten ausgeglichen',
        EXCEEDS_OPEN: 'Die Pläne übersteigen den aktuell offenen Betrag. Bitte anpassen oder aufheben.',
        ACCOUNT_UNAVAILABLE: 'Das vorgesehene Geldkonto ist nicht mehr verfügbar oder hat eine andere Währung.',
        overdue: 'Plantermin überschritten',
        all: 'Alle Pläne',
        empty: 'Keine Zahlungspläne für diese Auswahl.',
        noCandidates: 'Keine weiteren planbaren Rechnungen gefunden. Gebuchte Lieferantenrechnungen mit offenem, noch nicht verplantem Betrag werden hier angeboten.',
        searchInvoices: 'Lieferant oder Rechnungsnummer suchen',
        history: 'Änderungshistorie',
        CREATE: 'Angelegt',
        UPDATE: 'Geändert',
        CANCEL: 'Aufgehoben',
        by: 'Bearbeitet von',
        saved: 'Zahlungsplan gespeichert.',
        cancelled: 'Zahlungsplan aufgehoben.',
        totalsHint: 'Nominale Planbeträge der gefilterten Auswahl je Währung, ohne aufgehobene oder ausgeglichene Posten. Prüfhinweise können die Prognose vermindern; dies sind keine ausgeführten Zahlungen.',
        editHint: 'Teilbeträge und Termine sind frei planbar. Andere aktive Pläne werden berücksichtigt. Bei späteren Zahlungen werden Pläne nicht automatisch verändert.',
        selectInvoice: 'Rechnung auswählen',
        errors: {
            invoiceUnavailable: 'Die Rechnung ist nicht als offene, gebuchte Lieferantenrechnung verfügbar.',
            dateBeforeInvoice: 'Der Plantermin darf nicht vor der Rechnungsbuchung liegen.',
            exceedsAvailable: 'Der Teilbetrag übersteigt den noch planbaren offenen Betrag. Bitte aktualisieren und die Pläne prüfen.',
            accountCurrency: 'Wähle ein aktives Geldkonto in der Rechnungswährung oder lasse das Konto offen.',
            cancelled: 'Ein aufgehobener Plan kann nicht mehr bearbeitet werden.',
        },
        validation: {
            summary: 'Bitte die markierten Angaben prüfen. Deine Eingaben bleiben erhalten.',
            invoiceId: 'Wähle eine planbare Lieferantenrechnung.',
            plannedDate: 'Gib ein gültiges Kalenderdatum ein.',
            amount: 'Gib einen positiven Betrag mit höchstens vier Nachkommastellen ein, ohne Tausendertrennzeichen.',
            moneyAccountId: 'Wähle ein passendes Geldkonto oder lasse das Feld offen.',
            note: 'Die Notiz darf höchstens 1000 Zeichen enthalten.',
            reason: 'Gib eine Begründung mit 3 bis 1000 Zeichen ein.',
            dateRange: 'Das Enddatum muss am oder nach dem Startdatum liegen.',
        },
    },
    en: {
        sort: 'Sort order',
        version: 'Version',
        export: 'Export',
        title: 'Payment planning',
        hint: 'Plans outgoing payments for posted supplier invoices. A plan is not a payment, does not settle an item and is never sent to a bank.',
        add: 'Plan payment',
        edit: 'Edit plan',
        cancel: 'Cancel plan',
        cancelTitle: 'Cancel payment plan',
        cancelHint: 'The plan and its history are retained. Previously recorded payments remain in place.',
        invoice: 'Supplier invoice',
        partner: 'Supplier',
        plannedDate: 'Planned date',
        dueDate: 'Due date',
        amount: 'Planned instalment',
        currency: 'Currency',
        openAmount: 'Currently outstanding',
        plannedTotal: 'Total planned',
        availableAmount: 'Available to plan',
        moneyAccount: 'Intended money account',
        unassigned: 'Not yet selected',
        note: 'Note',
        reason: 'Reason for change',
        state: 'Status',
        warning: 'Review finding',
        PLANNED: 'Planned',
        CANCELLED: 'Cancelled',
        SETTLED: 'Item settled',
        EXCEEDS_OPEN: 'Plans exceed the current outstanding amount. Please adjust or cancel them.',
        ACCOUNT_UNAVAILABLE: 'The intended money account is no longer available or has a different currency.',
        overdue: 'Planned date passed',
        all: 'All plans',
        empty: 'No payment plans match this selection.',
        noCandidates: 'No further invoices are available to plan. Posted supplier invoices with outstanding amounts not yet planned appear here.',
        searchInvoices: 'Search supplier or invoice number',
        history: 'Change history',
        CREATE: 'Created',
        UPDATE: 'Changed',
        CANCEL: 'Cancelled',
        by: 'Changed by',
        saved: 'Payment plan saved.',
        cancelled: 'Payment plan cancelled.',
        totalsHint: 'Nominal planned amounts for the filtered selection, grouped by currency, excluding cancelled plans and settled items. Findings can reduce the forecast; these are not executed payments.',
        editHint: 'Plan instalments and dates freely. Other active plans are taken into account. Later payments do not silently change plans.',
        selectInvoice: 'Select invoice',
        errors: {
            invoiceUnavailable: 'This invoice is not available as an outstanding, posted supplier invoice.',
            dateBeforeInvoice: 'The planned date cannot precede invoice posting.',
            exceedsAvailable: 'The instalment exceeds the outstanding amount still available to plan. Refresh and review the plans.',
            accountCurrency: 'Select an active money account in the invoice currency or leave the account unassigned.',
            cancelled: 'A cancelled plan can no longer be edited.',
        },
        validation: {
            summary: 'Please check the highlighted fields. Your inputs are retained.',
            invoiceId: 'Select an available supplier invoice.',
            plannedDate: 'Enter a valid calendar date.',
            amount: 'Enter a positive amount with at most four decimal places and no thousands separators.',
            moneyAccountId: 'Select a suitable money account or leave it unassigned.',
            note: 'The note must not exceed 1000 characters.',
            reason: 'Enter a reason containing 3 to 1000 characters.',
            dateRange: 'The end date must be on or after the start date.',
        },
    },
    fr: {
        sort: 'Tri',
        version: 'Version',
        export: 'Exporter',
        title: 'Planification des paiements',
        hint: 'Prévoit les décaissements des factures fournisseurs comptabilisées. Un plan ne constitue pas un paiement, ne solde aucun poste et n’est jamais envoyé à une banque.',
        add: 'Planifier un paiement',
        edit: 'Modifier le plan',
        cancel: 'Annuler le plan',
        cancelTitle: 'Annuler le plan de paiement',
        cancelHint: 'Le plan et son historique sont conservés. Les paiements déjà enregistrés restent en place.',
        invoice: 'Facture fournisseur',
        partner: 'Fournisseur',
        plannedDate: 'Date prévue',
        dueDate: 'Échéance',
        amount: 'Montant partiel prévu',
        currency: 'Devise',
        openAmount: 'Solde ouvert actuel',
        plannedTotal: 'Total prévu',
        availableAmount: 'Montant encore planifiable',
        moneyAccount: 'Compte de trésorerie prévu',
        unassigned: 'Pas encore défini',
        note: 'Note',
        reason: 'Motif de la modification',
        state: 'Statut',
        warning: 'Point à vérifier',
        PLANNED: 'Prévu',
        CANCELLED: 'Annulé',
        SETTLED: 'Poste soldé',
        EXCEEDS_OPEN: 'Les plans dépassent le solde ouvert actuel. Veuillez les ajuster ou les annuler.',
        ACCOUNT_UNAVAILABLE: 'Le compte prévu n’est plus disponible ou utilise une autre devise.',
        overdue: 'Date prévue dépassée',
        all: 'Tous les plans',
        empty: 'Aucun plan ne correspond à cette sélection.',
        noCandidates: 'Aucune autre facture à planifier. Les factures fournisseurs comptabilisées ayant un solde ouvert non encore planifié apparaissent ici.',
        searchInvoices: 'Rechercher un fournisseur ou un numéro de facture',
        history: 'Historique des modifications',
        CREATE: 'Création',
        UPDATE: 'Modification',
        CANCEL: 'Annulation',
        by: 'Modifié par',
        saved: 'Plan de paiement enregistré.',
        cancelled: 'Plan de paiement annulé.',
        totalsHint: 'Montants nominaux prévus de la sélection filtrée par devise, hors plans annulés et postes soldés. Les points à vérifier peuvent réduire la prévision ; il ne s’agit pas de paiements exécutés.',
        editHint: 'Planifiez librement les montants partiels et les dates. Les autres plans actifs sont pris en compte. Les paiements ultérieurs ne modifient pas automatiquement les plans.',
        selectInvoice: 'Choisir une facture',
        errors: {
            invoiceUnavailable: 'Cette facture n’est pas disponible comme facture fournisseur comptabilisée et ouverte.',
            dateBeforeInvoice: 'La date prévue ne peut pas précéder la comptabilisation de la facture.',
            exceedsAvailable: 'Le montant partiel dépasse le solde encore planifiable. Actualisez et vérifiez les plans.',
            accountCurrency: 'Choisissez un compte actif dans la devise de la facture ou laissez le compte non défini.',
            cancelled: 'Un plan annulé ne peut plus être modifié.',
        },
        validation: {
            summary: 'Vérifiez les champs signalés. Vos saisies sont conservées.',
            invoiceId: 'Choisissez une facture fournisseur disponible.',
            plannedDate: 'Saisissez une date civile valide.',
            amount: 'Saisissez un montant positif avec au plus quatre décimales, sans séparateur de milliers.',
            moneyAccountId: 'Choisissez un compte adapté ou laissez-le non défini.',
            note: 'La note ne doit pas dépasser 1000 caractères.',
            reason: 'Saisissez un motif de 3 à 1000 caractères.',
            dateRange: 'La date de fin doit être égale ou postérieure à la date de début.',
        },
    },
    es: {
        sort: 'Orden',
        version: 'Versión',
        export: 'Exportar',
        title: 'Planificación de pagos',
        hint: 'Prevé salidas para facturas de proveedores contabilizadas. Un plan no es un pago, no liquida partidas y nunca se envía a un banco.',
        add: 'Planificar pago',
        edit: 'Editar plan',
        cancel: 'Cancelar plan',
        cancelTitle: 'Cancelar plan de pago',
        cancelHint: 'Se conservan el plan y su historial. Los pagos ya registrados permanecen.',
        invoice: 'Factura de proveedor',
        partner: 'Proveedor',
        plannedDate: 'Fecha prevista',
        dueDate: 'Vencimiento',
        amount: 'Importe parcial previsto',
        currency: 'Moneda',
        openAmount: 'Pendiente actual',
        plannedTotal: 'Total previsto',
        availableAmount: 'Disponible para planificar',
        moneyAccount: 'Cuenta de tesorería prevista',
        unassigned: 'Sin definir todavía',
        note: 'Nota',
        reason: 'Motivo del cambio',
        state: 'Estado',
        warning: 'Observación',
        PLANNED: 'Previsto',
        CANCELLED: 'Cancelado',
        SETTLED: 'Partida liquidada',
        EXCEEDS_OPEN: 'Los planes superan el importe pendiente actual. Ajústelos o cancélelos.',
        ACCOUNT_UNAVAILABLE: 'La cuenta prevista ya no está disponible o tiene otra moneda.',
        overdue: 'Fecha prevista superada',
        all: 'Todos los planes',
        empty: 'No hay planes para esta selección.',
        noCandidates: 'No hay más facturas disponibles. Aquí aparecen facturas de proveedores contabilizadas con saldo pendiente aún sin planificar.',
        searchInvoices: 'Buscar proveedor o número de factura',
        history: 'Historial de cambios',
        CREATE: 'Creación',
        UPDATE: 'Cambio',
        CANCEL: 'Cancelación',
        by: 'Modificado por',
        saved: 'Plan de pago guardado.',
        cancelled: 'Plan de pago cancelado.',
        totalsHint: 'Importes nominales previstos de la selección filtrada por moneda, excluyendo planes cancelados y partidas liquidadas. Las observaciones pueden reducir la previsión; no son pagos ejecutados.',
        editHint: 'Planifique importes parciales y fechas libremente. Se tienen en cuenta otros planes activos. Los pagos posteriores no modifican los planes automáticamente.',
        selectInvoice: 'Seleccionar factura',
        errors: {
            invoiceUnavailable: 'La factura no está disponible como factura de proveedor contabilizada y pendiente.',
            dateBeforeInvoice: 'La fecha prevista no puede preceder a la contabilización de la factura.',
            exceedsAvailable: 'El importe parcial supera el saldo aún disponible para planificar. Actualice y revise los planes.',
            accountCurrency: 'Seleccione una cuenta activa en la moneda de la factura o deje la cuenta sin definir.',
            cancelled: 'Un plan cancelado ya no puede editarse.',
        },
        validation: {
            summary: 'Revise los campos señalados. Se conservan sus datos.',
            invoiceId: 'Seleccione una factura de proveedor disponible.',
            plannedDate: 'Introduzca una fecha de calendario válida.',
            amount: 'Introduzca un importe positivo con hasta cuatro decimales y sin separadores de miles.',
            moneyAccountId: 'Seleccione una cuenta adecuada o déjela sin definir.',
            note: 'La nota no puede superar los 1000 caracteres.',
            reason: 'Introduzca un motivo de entre 3 y 1000 caracteres.',
            dateRange: 'La fecha final debe ser igual o posterior a la inicial.',
        },
    },
    tr: {
        sort: 'Sıralama',
        version: 'Sürüm',
        export: 'Dışa aktar',
        title: 'Ödeme planlaması',
        hint: 'Muhasebeleştirilmiş tedarikçi faturaları için çıkışları planlar. Plan bir ödeme değildir, açık kalemi kapatmaz ve bankaya gönderilmez.',
        add: 'Ödeme planla',
        edit: 'Planı düzenle',
        cancel: 'Planı iptal et',
        cancelTitle: 'Ödeme planını iptal et',
        cancelHint: 'Plan ve geçmişi korunur. Daha önce kaydedilmiş ödemeler korunur.',
        invoice: 'Tedarikçi faturası',
        partner: 'Tedarikçi',
        plannedDate: 'Planlanan tarih',
        dueDate: 'Vade',
        amount: 'Planlanan kısmi tutar',
        currency: 'Para birimi',
        openAmount: 'Güncel açık tutar',
        plannedTotal: 'Toplam planlanan',
        availableAmount: 'Planlanabilir tutar',
        moneyAccount: 'Öngörülen para hesabı',
        unassigned: 'Henüz belirlenmedi',
        note: 'Not',
        reason: 'Değişiklik gerekçesi',
        state: 'Durum',
        warning: 'İnceleme uyarısı',
        PLANNED: 'Planlandı',
        CANCELLED: 'İptal edildi',
        SETTLED: 'Kalem kapatıldı',
        EXCEEDS_OPEN: 'Planlar güncel açık tutarı aşıyor. Lütfen düzenleyin veya iptal edin.',
        ACCOUNT_UNAVAILABLE: 'Öngörülen para hesabı artık kullanılamıyor veya farklı para biriminde.',
        overdue: 'Planlanan tarih geçti',
        all: 'Tüm planlar',
        empty: 'Bu seçim için ödeme planı yok.',
        noCandidates: 'Planlanabilecek başka fatura bulunamadı. Henüz planlanmamış açık tutarı bulunan muhasebeleştirilmiş tedarikçi faturaları burada gösterilir.',
        searchInvoices: 'Tedarikçi veya fatura numarası ara',
        history: 'Değişiklik geçmişi',
        CREATE: 'Oluşturuldu',
        UPDATE: 'Değiştirildi',
        CANCEL: 'İptal edildi',
        by: 'Değiştiren',
        saved: 'Ödeme planı kaydedildi.',
        cancelled: 'Ödeme planı iptal edildi.',
        totalsHint: 'Filtrelenen seçimin para birimine göre nominal plan tutarlarıdır; iptal edilen planlar ve kapanmış kalemler hariçtir. Uyarılar tahmini azaltabilir; bunlar gerçekleşmiş ödemeler değildir.',
        editHint: 'Kısmi tutarları ve tarihleri serbestçe planlayın. Diğer etkin planlar dikkate alınır. Sonraki ödemeler planları sessizce değiştirmez.',
        selectInvoice: 'Fatura seç',
        errors: {
            invoiceUnavailable: 'Bu fatura açık ve muhasebeleştirilmiş tedarikçi faturası olarak kullanılamıyor.',
            dateBeforeInvoice: 'Planlanan tarih fatura muhasebeleştirme tarihinden önce olamaz.',
            exceedsAvailable: 'Kısmi tutar planlanabilir açık tutarı aşıyor. Yenileyip planları inceleyin.',
            accountCurrency: 'Fatura para biriminde etkin bir para hesabı seçin veya hesabı boş bırakın.',
            cancelled: 'İptal edilmiş plan artık düzenlenemez.',
        },
        validation: {
            summary: 'İşaretli alanları kontrol edin. Girdileriniz korunur.',
            invoiceId: 'Planlanabilir bir tedarikçi faturası seçin.',
            plannedDate: 'Geçerli bir takvim tarihi girin.',
            amount: 'Binlik ayırıcı kullanmadan en fazla dört ondalık basamaklı pozitif tutar girin.',
            moneyAccountId: 'Uygun bir para hesabı seçin veya boş bırakın.',
            note: 'Not en fazla 1000 karakter olabilir.',
            reason: '3 ile 1000 karakter arasında bir gerekçe girin.',
            dateRange: 'Bitiş tarihi başlangıç tarihiyle aynı veya daha sonra olmalıdır.',
        },
    },
};
//# sourceMappingURL=ledger-payment-plans.js.map